import { CaretRight } from '@phosphor-icons/react';
import { CATEGORIES } from '../../../../../shared/constants/categories';
import { formatDate } from '../../../../../shared/utils/date';

type HistoryListProps = {
  places: any[];
  t: any;
  onOpen: (place: any) => void;
};

export default function HistoryList({ places, t, onOpen }: HistoryListProps) {
  return (
    <div className="history-list">
      {places.map((place) => {
        const category = CATEGORIES[place.type as keyof typeof CATEGORIES];
        return (
          <button key={place.id} onClick={() => onOpen(place)}>
            <img src={place.image || '/place-placeholder.svg'} alt="" />
            <span>
              <b>{place.name}</b>
              <small>
                <category.Icon weight="fill" />
                {t[place.type]} · {place.address}
              </small>
            </span>
            <span className="history-date">
              <small>{t.created}</small>
              {formatDate(place.createdAt, t.locale)}
            </span>
            <CaretRight />
          </button>
        );
      })}
    </div>
  );
}
